export const authConstants = {
    LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USER_LOGIN_FAILURE',
    SET_USER_LOADING: 'SET_USER_LOADING',
    SET_USER: 'SET_USER',
    LOGOUT: 'USERS_LOGOUT',
    CLEAR_STORE: 'CLEAR_STORE',
};

export const ROLE = {
    SUPER_ADMIN: 0,
    ADMIN: 1,
    USER: 2,
};

export const ACCESS_LEVEL = {
    GLOBAL: 0,
    BRAND: 1,
    LOCATION: 2,
};

export const RIGHTS = {
    READ: 'r',
    WRITE: 'w',
};
